export const DEFAULT_UNIT = 'unit-1'
export const CORE_UNITS_LABEL = 'Core'
export const BULLYING_UNITS_LABEL = 'Recognizing Bullying & Harassment'

export const OptionalUnits = {
  BullyingHarassmentUnit: {
    slug: 'recognizing-bullying-and-harassment',
    // FIX: Hopefully its temporary and there will be a better to identify H&B lessons in Course Manager.
    courseNodeIds: [
      'X5S6Sit9WKHgMRbXYQOs1',
      '2H6iYvNCaE86l3RBvbIr3O',
      '33Gc0lwEcMNAtcE2a2Znkh',
    ],
  },
}
